import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React from 'react'
import { coloBlindnessOption } from './formOptions'
import RadioButtonController from '../../../../components/RadioButtonController/RadioButtonController'
import { ParentContainerSection } from '../DiabeticForm'

const ColorBlindTest = (props) => {
    const { control, errors } = props

    const colorBlindTest=[
        {label:"L", formFieldName:"color_blindness_left", option: coloBlindnessOption },
        {label:"R", formFieldName:"color_blindness_right", option: coloBlindnessOption },
    ]

  return (
    <ParentContainerSection heading="Section E: Color Blindness Test" requiredStar>
        <TableContainer component={Paper} sx={{ mb: "1rem" }}>
      <Table sx={{ maxWidth: 450, '& td, & th': { border: '0.5px solid lightgray' } }} aria-label="color blind table">
        <TableHead>
          <TableRow >
            <TableCell rowSpan={2}></TableCell>
            <TableCell align="left">None</TableCell>
            <TableCell align="left">Red/Green</TableCell>
            <TableCell align="left">Blue/Yellow</TableCell>
            <TableCell align="left">Complete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {colorBlindTest.map((blindRow,index)=>(
            <TableRow key={index}>
            <TableCell>{blindRow.label}</TableCell>
            {blindRow.option.map((item, optionInd)=>(
                <TableCell align="right" key={optionInd}>
                <RadioButtonController 
                                name={blindRow.formFieldName}
                                isRow={true}
                                control={control}
                                errors={errors}
                                options={[item]}
                                isMargin={false}
                                isDisabled
                            />
                            </TableCell>
            ))}
          </TableRow>
        ))}
        </TableBody>
      </Table>
    </TableContainer>
    </ParentContainerSection>
  )
}

export default ColorBlindTest